

import React from 'react';
import {useTranslation} from "react-i18next";
import Section from "../basic/layouts/section";
import {MouseParallax} from "react-just-parallax";
import '../styles/book.css';
import BooksSection from "./products/book";
import {MotionAnimate} from "react-motion-animate";
import * as FaIcons from "react-icons/fa";
import {Link} from "react-router-dom";

function SectionProducts(props) {

    const { t, i18n } = useTranslation()

    return (<div id={'products'}>

        <div className="text-center">
            <div id={'whtat-todo__title-position'} className="p-md-5 p-2">
                <small className="text-secondary">
                    {/*products*/}
                    {t('subTitle.available')}
                </small>

                <h2 className={'display-1'}>
                    {/*Books & Apps*/}
                    {t('nav.products')}
                </h2>

            </div>
        </div>

        <Section title={''} name={''} child={<div className={'rounded-5'}>

            <div className="container -fluid">
                <div className="d-flex flex-wrap justify-content-between align-items-start">

                    <div className="col-md-6 col-12 p-2">
                        <div className="border rounded-5 cover1" style={{height: '50vh'}}>
                            {/*<img src="https://growthukraine.com/assets/app/app3.png" alt="iphone" className={'img-fluid'}/>*/}
                            {/*<img src="https://apps.lukyanchuk.com/image/iphoneNEW.png" alt="iphone" className={'img-fluid'}/>*/}
                            <div className="p-5">
                                <FaIcons.FaCodeBranch color={'black'} size={58} />
                            </div>
                            <h2 className={'text-dark p-5 pb-1'}>{t('Make great product to gather')}...</h2>
                            <p className={'text-dark p-5 pt-0'}>
                                <Link to={'/inquire'} className={'btn btn-dark shadow-lg p-3 d-flex align-items-center justify-content-center col-md-4 col-12 rounded-5'}>
                                    {t('inquire / cooperation')}
                                </Link>
                            </p>

                        </div>
                    </div>

                    <div className="col-md-6 col-12 p-2">
                        <div className="border rounded-5 cover1 align-items-center justify-content-center d-flex flex-wrap bg-dark text-white" style={{height: '50vh'}}>

                            <div className="col-md-6 col-12 text-center">
                               <div className="text-start p-5">
                                   <img src="/assets/img/products/random-app.png" alt="logo" className={'rounded shadow-lg'} width={'50'}/>
                                   <h3 className={'mt-3'}>Random App</h3>
                                   <p>
                                       Simple app for creators
                                   </p>

                                   <div className="d-flex pt-3">
                                       <a href="https://play.google.com/store/apps/details?id=com.lukyanchuk.random_app" target={'_blank'}>
                                           <img src="/assets/img/products/android.svg" alt=""/>
                                       </a>
                                       <Link
                                           to="https://apps.lukyanchuk.com/app/random-app"
                                           className="btn btn-light shadow-lg p-2 d-flex align-items-center justify-content-center col-md-12 col-12 rounded-5">
                                           <span className="display- lead m-0">
                                               {t('know.more')}
                                           </span>
                                       </Link>
                                       <a href="https://apps.y-l.pro/app/random-app" target={'_blank'} className={'d-none nav-link text-white p-2 d-flex align-items-center p-3'}>
                                               <svg className="w-5 h-4 text-gray-800 dark:text-white" aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none"
                                                    viewBox="0 0 24 24">
                                                   <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                                         stroke-width="2"
                                                         d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
                                               </svg>

                                               <small className={'p-2'}>{t('know.more')}</small>
                                       </a>
                                   </div>
                               </div>
                            </div>
                            <div className="col-md-6 d-none d-md-block text-center">
                                <MotionAnimate
                                    animation='fadeInUp'
                                    reset={true}
                                    distance={100}
                                    delay={1}
                                    speed={1}>
                                    <img src="/assets/img/products/iphone.png" alt="iphone" className={'img-fluid'}/>
                                </MotionAnimate>
                            </div>

                            {/*<img src="https://tehnomag.com/upload/catalog/product/5020/thumb/apple-iphone-14-plus-blue-a_63516ea26f734_650xr.png" alt="iphone" className={'img-fluid rounded-5'}/>*/}
                        </div>
                    </div>

                    {/*<div className="col-md-12 col-12 p-2">*/}
                    {/*    <div className="border rounded-5" style={{height: '55vh'}}>*/}

                    {/*        <BooksSection />*/}

                    {/*    </div>*/}
                    {/*</div>*/}

                </div>
            </div>

        </div>} link={'/'} linkName={''}/>


    </div>);
}

export default SectionProducts;
